<template>
	<div class="my-2">
		<label v-if="label" class="mb-2 small text-dark fs-6" :for="label"
			>{{ label }}
			<span v-if="required" class="text-danger">*</span>
		</label>
		<input
			v-bind="$attrs"
			:id="id"
			:value="modelValue"
			:placeholder="name"
			@input="
				$emit('update:modelValue', $event.target.value),
					validate($event.target.value)
			"
			:class="class"
			autocomplete="off"
		/>

		<span v-if="validationState.error" class="text-danger required-field">{{
			validationState.message
		}}</span>
	</div>
</template>
<script>
	import validator from "@/config/validator";
	import { reactive } from "vue";

	export default {
		props: {
			id: {
				type: [String, Number],
				default: null,
			},
			label: {
				type: String,
				default: null,
			},
			modelValue: {
				type: [String, Number, Array, Function],
				default: null,
			},
			name: {
				type: String,
			},
			rules: {
				type: String,
				default: null,
			},
			required: {
				type: Boolean,
				default: false,
			},
			class: {
				type: String,
				default: "form-control form-control-lg",
			},
		},

		setup(props, { emit }) {
			const validationState = reactive({
				error: false,
				field: null,
				message: null,
			});

			const setState = function (data = false) {
				validationState.error = data.val || false;
				validationState.message = data.message || null;
				validationState.field = data.name || null;
			};

			const validate = async function (value) {
				if (!props.rules)
					return emit("valSuccess", { error: false, field: props.name });
				try {
					let result = await validator.validateForm(
						props.name,
						props.rules,
						value,
					);
					if (!result.success) {
						setState({
							val: true,
							message: result?.message,
							name: result?.field_name,
						});
						emit("valError", { error: true, field: result?.field_name });
						return;
					}
					setState();
					emit("valSuccess", { error: false, field: result?.field_name });
					return;
				} catch (err) {
					console.log(err);
				}
				return;
			};

			return {
				validate,
				validationState,
			};
		},
	};
</script>
<style scoped>
	.dashInput {
		background: rgba(255, 255, 255, 0.789);
		outline: none;
		box-shadow: none;
		border-radius: 5px;
		padding: 4px 0 4px 10px;
		color: rgb(0, 0, 0);
	}
	.formInputs {
		border-bottom: 2px solid #fff;
		outline: none;
		box-shadow: none;
		padding: 2px 0;
		color: rgb(0, 0, 0);
		line-height: 1rem;
		font-size: 25px;
	}
	input::placeholder {
		color: #898989;
		font-size: 13px;
	}

	input:-webkit-autofill {
		border: 3px solid blue;
	}
	input:autofill {
		border: 3px solid #0000ff;
	}
	.form-control-lg{
		font-size: .8rem;
	}
	input[type=text]{
    border: none;
	background: rgb(0 172 223 / 9%);
	}
	input[type=number]{
    border: none;
	background: rgb(0 172 223 / 9%);
	}
	input[type=email]{
    border: none;
	background: rgb(0 172 223 / 9%);
	}
	label.mb-2.small.text-dark.fs-6 {
    color: #00A0E3 !important;
}
.change-input {
    background: #009fe321;
    border: 1px solid #00A0E3 !important;
	padding: 10px 20px;
}
.required-field{
	font-size: 15px;
}
</style>
